// src/extenders/button-tooltip.js
var ButtonTooltip = class extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector("[data-tooltip-trigger]");
    this.tooltip = this.querySelector("[role=tooltip]");
    this.globalEscapeBound = this._globalEscape.bind(this);
    this.globalPointerDownBound = this._globalPointerDown.bind(this);
  }
  connectedCallback() {
    this._bindEvents();
  }
  _bindEvents() {
    this.addEventListener("mouseenter", this.open.bind(this));
    this.addEventListener("touchstart", this.open.bind(this));
    this.addEventListener("mouseleave", this.close.bind(this));
    this.trigger.addEventListener("focus", this.open.bind(this));
    this.trigger.addEventListener("blur", this.close.bind(this));
    window.addEventListener("resize", this._checkBounding.bind(this));
  }
  _attachGlobalListener() {
    document.addEventListener("keydown", this._globalEscapeBound);
    document.addEventListener("pointerdown", this._globalPointerDownBound);
  }
  _removeGlobalListener() {
    document.removeEventListener("keydown", this._globalEscapeBound);
    document.removeEventListener("pointerdown", this._globalPointerDownBound);
  }
  _globalEscape(event) {
    if (event.code === "Escape" || event.keyCode === 27) {
      this.close();
    }
  }
  _globalPointerDown(event) {
    const target = event.target;
    if (target === this || target === this.trigger || target === this.tooltip) {
      event.preventDefault();
      return;
    }
    this.close();
    this.trigger.blur();
  }
  _checkBounding() {
    this.tooltip.removeAttribute("style");
    if (this.tooltip.getBoundingClientRect().right > window.innerWidth) {
      this.tooltip.style.left = "unset";
      this.tooltip.style.right = "0.5rem";
    }
  }
  open() {
    this._checkBounding();
    this.tooltip.setAttribute("aria-hidden", "false");
    this._attachGlobalListener();
  }
  close() {
    this.tooltip.setAttribute("aria-hidden", "true");
    this._removeGlobalListener();
  }
};
if (!window.customElements.get("button-tooltip")) {
  window.customElements.define("button-tooltip", ButtonTooltip);
}
